/* import __COLOCATED_TEMPLATE__ from './step-content.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();